/**
 * openHouseTemplates.js — Follow-up text templates + scorecard benchmarks
 * for the Open House Planner (/openhouse).
 *
 * Used by FollowUpTab (composer) and PlaybookTab (benchmarks line).
 * Templates use {{key}} merge tags filled by fillOhTemplate — unknown
 * tags are left intact so the sender can spot missing context.
 */

export const FOLLOWUP_TEMPLATES = [
  {
    id: 'same_evening',
    label: 'Same evening — met + shot',
    body: "Great meeting you at {{address}} today — footage looks fantastic. Your video hits your phone tomorrow by noon. — {{senderName}}, Roto Flight Media",
  },
  {
    id: 'video_delivery',
    label: 'Next day — video delivery',
    body: "{{firstName}} — here's your open house reel for {{address}}: {{videoLink}}\nVertical + horizontal cuts, downloadable, no watermark — fully yours to post. Mind if we tag you when we share ours? — {{senderName}}, Roto Flight Media",
  },
  {
    id: 'no_shoot_nice_to_meet',
    label: 'Met, no shoot — series sample',
    body: "{{firstName}}, good meeting you at {{address}} today. Here's the kind of piece we're shooting for the Open House Series this month: {{videoLink}} — if you'd like your next listing in the series, just say the word. — {{senderName}}, Roto Flight Media",
  },
  {
    id: 'week_later_bridge',
    label: '~1 week — bridge to paid',
    body: "{{firstName}} — glad the {{address}} reel worked out! When your next listing goes live we'd love to do the full treatment (video + photos + aerials). Series alums get first-shoot pricing. — {{senderName}}",
  },
];

/**
 * Fill {{key}} merge tags in a template body from ctx.
 * Unknown/empty keys are left intact (so '{{videoLink}}' stays visible
 * until a tracked link exists).
 */
export function fillOhTemplate(body, ctx = {}) {
  return String(body || '').replace(/\{\{(\w+)\}\}/g, (match, key) => {
    const val = ctx[key];
    return val === undefined || val === null || val === '' ? match : String(val);
  });
}

/** Benchmarks for the PlaybookTab live scorecard. */
export const SCORECARD_TARGETS = {
  housesPerDay: '3–6',
  convosPerDay: '4–6',
  shootsPerDay: '2–3',
  deliveryHours: 24,
};
